<form #modalForm="ngForm" (ngSubmit)="onSubmit()">
  <div class="flex flex-col px-5 py-1 gap-5 max-h-[75vh] overflow-y-auto">
    <div>
      <p-message severity="error" variant="outlined" class="mt-2" [ngClass]="{'hidden': !fileError, 'inline-block': fileError}">
        <span [innerHTML]="fileError"></span>
      </p-message>
      <p-fileupload #fileUpload name="file" [multiple]="false" [showUploadButton]="false" (onSelect)="onFileSelect($event)" (onUpload)="onFileUpload($event)" (onClear)="onFileClear($event)" (onRemove)="onFileRemove($event)" accept="image/jpeg,image/png,image/webp" maxFileSize="10485760" mode="advanced">
        <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback">
          <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
            <div class="flex gap-2">
              <p-button (click)="chooseCallback()" icon="pi pi-image" label="Choisir" [outlined]="true" />
              <p-button (click)="clearCallback()" icon="pi pi-times" label="Annuler" [outlined]="true" severity="danger" [disabled]="!files || files.length === 0" />
            </div>
          </div>
        </ng-template>
        <ng-template #empty>
          <div class="flex items-center justify-center flex-col cursor-pointer pt-4" (click)="fileUpload.choose()">
            <i class="pi pi-search !border-2 !rounded-full !p-8 !text-4xl !text-muted-color"></i>
            <p class="mt-4 mb-0 text-center">
              Glisser et déposez ici une image utilisée pour la recherche OCR.<br>
              Image au format <code>JPEG</code> / <code>PNG</code> / <code>WEBP</code> uniquement, taille maximale de 10 Mo.
            </p>
          </div>
        </ng-template>
      </p-fileupload>
    </div>
  </div>

  <div class="flex flex-row justify-between px-5 pt-5">
    <p-button label="Annuler" icon="pi pi-times" text severity="danger" (click)="hideDialog()" />
    <p-button label="Rechercher" icon="pi pi-save" iconPos="right" type="submit" [disabled]="fileUpload && !fileUpload.hasFiles()" [loading]="isSendingDatas" (click)="onSubmit()" />
  </div>
</form>